<template>
	<ui-modal @toggle="$emit('toggle')">
		<Head title="Gestion des rappels" />
		<div class="flex flex-col" v-if="!loading">
			<ui-title textSize="big" textPosition="left" class="lg:col-span-2 text-slate-700 mb-5">
				<template v-slot:text>
					<p>Rappels</p>
				</template>
				<template v-slot:actions>
					<ui-button @click.prevent="displayReminderAdd = !displayReminderAdd">
						<template v-slot:icon><i class="fas fa-circle-plus"></i></template>
						<template v-slot:text>Ajouter un rappel</template>
					</ui-button>
				</template>
			</ui-title>
			<form-validation-errors class="lg:col-span-2"></form-validation-errors>
			<form
				@submit.prevent="doUpdate()"
				@keyup.enter="doUpdate()"
				class="flex flex-col lg:grid lg:grid-cols-2 lg:col-span-2 gap-3 w-full"></form>
			<partial-add-reminder v-if="displayReminderAdd" search="all" :loading="formLoading" @send="reminderAdd($event)" class="mb-2" />
			<ui-reminder
				v-if="reminders?.length > 0"
				v-for="reminder in reminders"
				:key="reminder.id"
				:reminder="reminder"
				@check="reminderCheck($event)"
				class="odd:bg-white even:bg-sky-50">
			</ui-reminder>
			<ui-alert v-else type="success"> Aucun rappel pour l'instant. </ui-alert>
		</div>
		<div v-else class="h-full w-full flex items-center justify-center text-2xl">
			<i class="fas fa-circle-notch fa-spin"></i>
		</div>
	</ui-modal>
</template>

<script setup>
	import { ref, onMounted } from 'vue';
	import { Head, useForm } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';
	import axios from 'axios';

	const emit = defineEmits(['toggle']);

	const loading = ref(true);
	const formLoading = ref(false);
	const displayReminderAdd = ref(false);
	const reminders = ref([]);
	const form = useForm({
		targetable_type: null,
		targetable_id: null,
		comment: null,
	});

	const getReminders = () => {
		loading.value = true;
		axios
			.get(route('reminders.all'))
			.then((response) => {
				reminders.value = response.data;
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				loading.value = false;
			});
	};

	const reminderAdd = (data) => {
		toast.info("Rappel en cours d'ajout");
		formLoading.value = true;
		form.targetable_type = data.targetable_type;
		form.targetable_id = data.targetable_id;
		form.comment = data.comment;

		form.post(route('reminders.store'), {
			onSuccess: () => {
				toast.success('Rappel ajouté avec succès !');
				displayReminderAdd.value = false;
				getReminders();
			},
			onError: () => {
				toast.error('Une erreur est survenue');
			},
			onFinish: () => {
				formLoading.value = false;
			},
		});
	};

	const reminderCheck = (reminder) => {
		// Logique pour gérer le check d'un rappel
		// Par exemple, mettre à jour le statut du rappel
	};

	onMounted(() => {
		getReminders();
	});
</script>
